export { AtnDsEmptyStateComponent as Component } from './empty-state.component'
